import controlStyles from './wizard-controls.module.css';

export type WizardSelectOption = {
  value: string;
  label: string;
};

export interface WizardSelectProps {
  value?: string;
  options: WizardSelectOption[];
  placeholder?: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  id?: string;
  'aria-label'?: string;
  'data-testid'?: string;
}

export default function WizardSelect({
  value = '',
  options,
  placeholder,
  onChange,
  hasError = false,
  id,
  'aria-label': ariaLabel,
  'data-testid': testId,
}: WizardSelectProps) {
  const showPlaceholder = !value;

  return (
    <select
      id={id}
      aria-label={ariaLabel}
      data-testid={testId}
      className={`${controlStyles.select} ${hasError ? controlStyles.selectError : ''} ${showPlaceholder ? controlStyles.selectPlaceholder : ''}`.trim()}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      required={Boolean(placeholder)}
    >
      {placeholder ? (
        <option value="" disabled hidden>
          {placeholder}
        </option>
      ) : null}
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
